<div class="client-search-page my-1">
  <div class="container-fluid px-2">
    <div class="idlight client-search-panel ms-auto me-auto rounded-2 shadow-3-strong p-3 m-2">
    <form [formGroup]="clientSearchForm" class="inline">
      <div class="input-group client-search-group justify-content-center align-items-center gap-lg-3 gap-md-1 gap-sm-0">
        <label for="idNumber" class="input-group-text border-0" style="font-size: 0.9rem;">Id Number</label>
        <input type="search" class="form-control ms-2 rounded" placeholder="Enter Id Number"
          formControlName="idNumber" lmsNumbersOnly [allowPaste]="true" [allowDecimals]="false" required
          maxlength="13" autofocus />
        <!-- </span> -->
        <div class="input-group-text border-0 d-none d-md-flex client-search-action">
          <button class="btn btn-primary" type="button" mdbRipple (click)="getClient()">Search</button>
        </div>
        <div class="error-message"
          *ngIf="clientSearchForm.controls['idNumber']?.errors && (clientSearchForm.controls['idNumber']?.dirty || clientSearchForm.controls['idNumber']?.touched)">

          <label mdbLabel *ngIf="clientSearchForm.controls['idNumber']!.errors?.notfound" class="error-label">
            Id Number not found!
          </label>
          <label *ngIf="clientSearchForm.controls['idNumber']!.errors?.maxlength" class="error-label">
            Must be a valid Id Number
          </label>
          <label *ngIf="clientSearchForm.controls['idNumber']!.errors?.wrongBranch" class="error-label">
            Incorrect Branch selection!
          </label>
        </div>
      </div>
    </form>
  </div>
    <!-- <div class="idlight ms-auto me-auto rounded-2 shadow-3-strong p-2 m-1" style="max-width: 45vw;">
      <form [formGroup]="clientSearchForm">
        <div class="input-group">
          <span class="input-group-text border-0" id="idNumberLabel">Id Number</span>
          <input mdbValidate mdbInput type="search" name="idNumber" id="idNumber" class="form-control"
            (input)="isSearchClient = false;" placeholder="Enter Id Number" formControlName="idNumber" maxlength="13"
            lmsNumbersOnly [allowPaste]="true" [allowDecimals]="false" aria-label="Id Number" aria-describedby="idNumberLabel" autofocus>
          <button class="btn btn-primary" type="button" mdbRipple data-mdb-ripple-color="#fafafa"
            (click)="getClient()">Search</button>
        </div>
        <div *ngIf="idNumber?.errors?.required && isSubmitted" class="mt-1">
          <small class="text-danger">Client's ID number is required.</small>
        </div>
        <div *ngIf="idNumber?.errors?.validationResult" class="mt-1">
          <small class="text-danger">{{idNumber?.errors?.validationResult.message}}</small>
        </div>
        <div *ngIf="idNumber!.invalid" class="mt-1">
          <mdb-error mdbLabel *ngIf="idNumber?.errors!.notfound">
            Id Number not found!
          </mdb-error>
          <mdb-error *ngIf="idNumber?.errors!.maxlength || idNumber!.errors?.minlength">
            Must be a valid Id Number
          </mdb-error>
          <mdb-error *ngIf="idNumber!.errors?.wrongBranch">
            Incorrect Branch selection!
          </mdb-error>
        </div>
      </form>
    </div> -->

    <ng-container *ngIf="isSearchClient">
      <div class="idlight client-search-results d-flex ms-auto me-auto p-2 bg-default rounded-2 shadow-3-strong">
        <div class="container mt-2">
          <div class="row justify-content-center center-section ">
            <table class="table table-striped table-light table-hover table-sm lms-table__grid caption-top">
              <caption>
                Client / Account filter
              </caption>
              <thead class="center-header">
                <tr>
                  <th>Application #</th>
                  <th>Id Number</th>
                  <th>Name </th>
                  <th>Surname</th>
                  <th>Cell Number</th>
                  <th>Status</th>
                  <th>User</th>
                  <th *ngIf="resetLoan"> Manage Reference No.</th>
                  <th> View </th>
                </tr>
              </thead>
              <tbody role="rowgroup">
                <tr>
                  <td>{{preAuthorisationModel.id}}</td>
                  <td>{{preAuthorisationModel.idNumber}}</td>
                  <td>{{preAuthorisationModel.firstName}}</td>
                  <td>{{preAuthorisationModel.lastName}}</td>
                  <td>{{preAuthorisationModel.cellNumber}}</td>
                  <td>
                    <ng-container *ngIf="!!preAuthorisationModel.loanStatus">
                      <span class="rounded-pill d-inline badge"
                        [ngClass]="{'badge-primary': (preAuthorisationModel.loanStatus === 'Active'),
                    'badge-info':(preAuthorisationModel.loanStatus === 'New' || preAuthorisationModel.loanStatus=== 'Pending'),
                    'badge-success':(preAuthorisationModel.loanStatus === 'Submitted'),
                    'badge-dark': (preAuthorisationModel.loanStatus === 'Cancelled' || preAuthorisationModel.loanStatus === 'Rejected'),
                    'badge-secondary': (preAuthorisationModel.loanStatus === 'Disbursed' || preAuthorisationModel.loanStatus === 'NuPay')}">
                        {{preAuthorisationModel.loanStatus}}</span>
                    </ng-container>


                  </td>
                  <!-- <td style="width: 100px;">{{preAuthorisationModel.loanStatus}}</td> -->
                  <td>{{preAuthorisationModel.userName}}</td>
                  <td *ngIf="!resetLoan" style="width: 100px;">
                    <button (click)="viewSearchedClient(preAuthorisationModel)" data-mdb-ripple-color="#fafafa"
                      class="btn btn-sm btn-primary btn-rounded" type="button" mdbRipple
                      [textContent]="preAuthorisationModel.status === 'Submitted' ? 'View' : 'Continue'"></button>
                  </td>

                  <td *ngIf="resetLoan">
                    <input #referenceNumber placeholder="Manage Engine Reference No." required>
                  </td>

                  <td *ngIf="resetLoan">
                    <button class="btn btn-primary btn-rounded" mdbRipple type="button"
                      (click)="resetLoanApplication(preAuthorisationModel)">Reset
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
